import React from 'react';
import { variables } from './Variables';

const Footer = () => (
  <div className="">
    <p className="dark:text-gray-500 text-gray-700 text-center " style={{ marginTop: '150px' }}>
      {variables.COPYRIGHT}
    </p>
  </div>
);

export default Footer;
